import React from 'react';

import CardHOC from './Components/CardHOC';
import YesNo from '../../Types/Components/YesNo';

export default function (props) {
  return <CardHOC question={props.question}>
    <YesNo {...props} />
  </CardHOC>;
}